export default __webpack_public_path__ + "static/media/img_1.d4c5fcc9.png";